import React, { useEffect, useRef } from 'react';

const Roller = () => {
  const rollerRef = useRef(null);

  useEffect(() => {
    const roller = rollerRef.current;
    if (!roller) return;

    // Clone the content to create a seamless loop
    const content = roller.innerHTML;
    roller.innerHTML = content + content;

    // Set up the animation
    const animate = () => {
      if (roller.scrollTop >= roller.scrollHeight / 2) {
        roller.scrollTop = 0;
      } else {
        roller.scrollTop += 1;
      }
    };

    const intervalId = setInterval(animate, 25);

    // Clean up on unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <section className='py-20 bg-black overflow-hidden'>
      <div className='container mx-auto px-4 max-w-6xl'>
        <div className='text-center mb-12'>
          <h2 className='text-3xl md:text-4xl font-bold text-white mb-4'>
            Your Journey to Greatness
          </h2>
          <p className='text-lg text-gray-300 max-w-2xl mx-auto'>
            Every step forward is a step toward transformation
          </p>
        </div>

        <div className='relative h-52 md:h-72 flex items-center justify-center'>
          {/* Glowing background effect */}
          <div className='absolute inset-0 bg-yellow-500/10 blur-3xl rounded-full'></div>

          {/* Text roller container */}
          <div
            ref={rollerRef}
            className='relative h-20 md:h-32 overflow-hidden w-full max-w-md mx-auto'
            style={{
              maskImage:
                'linear-gradient(to bottom, transparent, black 10%, black 90%, transparent)',
              WebkitMaskImage:
                'linear-gradient(to bottom, transparent, black 10%, black 90%, transparent)',
            }}
          >
            <div className='flex flex-col items-center justify-center text-center'>
              <div className='text-5xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-blue-600 py-2'>
                Freedom
              </div>
              <div className='text-5xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500 py-2'>
                Momentum
              </div>
              <div className='text-5xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-green-600 py-2'>
                Habit
              </div>
              <div className='text-5xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-600 py-2'>
                Achievement
              </div>
              <div className='text-5xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-yellow-500 py-2'>
                Ignite
              </div>
              <div className='text-5xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600 py-2'>
                Awakening
              </div>
            </div>
          </div>

          {/* Decorative elements */}
          <div className='absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-20 bg-gradient-to-b from-yellow-500 to-transparent'></div>
          <div className='absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1 h-20 bg-gradient-to-t from-yellow-500 to-transparent'></div>
        </div>

        <div className='text-center mt-12'>
          <p className='text-gray-300'>
            Join TheChamps and discover your path to greatness
          </p>
        </div>
      </div>
    </section>
  );
};

export default Roller;
